import React, { Component } from 'react';
import './index.scss';
import iconLiked from '../../../../assets/images/icon-heart-white.svg';

class FavoriteItem extends Component {
  render() {
    return (
      <li className="CardBox FavoriteItem">
        <figure
          className="FavoriteImage"
          style={{
            backgroundImage: `url(${ this.props.image })`
          }} />

        <span className="FavoriteTag">Aluguel</span>

        <div className="FavoriteDescription">
          <h4 className="FavoriteValue">{ this.props.value }</h4>

          <article className="FavoriteText">
            <h5>{ this.props.title }</h5>
            <p>{ this.props.description }</p>
            {
              this.props.children
            }
          </article>

          <button className="ButtonLike">
            <img src={ iconLiked } alt="Favorito" />
          </button>
        </div>
      </li>
    )
  }
}

export default FavoriteItem;
